module.exports = __webpack_public_path__ + "img/calentadores.6d308547.png";